@if (loaderStore.isLoading()) {
  <div class="zelo-loader-overlay">
    <nz-spin nzSimple [nzSize]="'large'" />
  </div>
}
